module.exports = __webpack_public_path__ + "static/media/CustomEmails.29152541.svg";